import { type Middleware } from '@reduxjs/toolkit';
/**
 * Middleware to queue and persist actions in localStorage.
 * Actions with `meta.queue` set to `true` will be stored in localStorage under the specified storage key.
 * Optionally prevents immediate dispatching of the action using `meta.preventDispatch`.
 *
 * @param {string} storageKey - The key used to store the action queue in localStorage.
 * @returns {Function} Middleware function to intercept and process actions.
 */
export const createActionQueueMiddleware =
  (storageKey: string): Middleware =>
  (/* store: AppRootStore */) =>
  (next) =>
  (action) => {
    if (action.meta?.queue) {
      const queue = JSON.parse(localStorage.getItem(storageKey) || '[]');
      // Add the current action to the queue
      queue.push(action);

      // Persist the updated queue to localStorage
      localStorage.setItem(storageKey, JSON.stringify(queue));

      // If preventDispatch is true, do not dispatch the action
      if (action.meta.preventDispatch) {
        return;
      }
    }

    // Dispatch the action normally
    return next(action);
  };
